import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/navbar/index.jsx';
import Footer from '../../components/Footer/Footer.js';
import WaFloat from '../../components/WaFloat/WaFloat.jsx';
import { useReveal } from '../../hooks/useReveal.js';

const sectors = [
  { n: '⚕', h: 'Healthcare', p: "Hospital networks, diagnostics, specialty clinics, pharmaceutical manufacturers, and healthcare technology. India's healthcare capital cycle is accelerating.", cap: '₹15–300 Cr' },
  { n: '⚙', h: 'Manufacturing', p: 'PLI-linked manufacturers, auto components, specialty chemicals, and engineering goods. The largest manufacturing capex cycle in a decade is underway.', cap: '₹20–500 Cr' },
  { n: '◈', h: 'Logistics', p: '3PL operators, cold chain networks, e-commerce infrastructure, and freight platforms. Growing at 10–12% CAGR with consistent capital demand.', cap: '₹10–150 Cr' },
  { n: '◉', h: 'Consumer Brands', p: 'D2C, regional FMCG, food and beverage, and lifestyle brands scaling nationally. The most compelling sector for domestic family offices and HNIs.', cap: '₹15–200 Cr' },
  { n: '◎', h: 'Fintech & BFSI', p: 'NBFCs, lending platforms, wealth technology, and insurance distribution. Complex engagements where regulatory fluency and senior credibility are essential.', cap: '₹20–300 Cr' },
  { n: '◈', h: 'Exports', p: "Merchandise exporters, agri-export companies, and engineering goods manufacturers with international order books. India's export push is creating sustained capital demand.", cap: '₹10–200 Cr' },
];

export default function Sectors() {
  useReveal();
  return (
    <>
      <Navbar />

      <div className="page-hero about-hero">
        <div className="about-hero-wrap">
          <div className="page-hero-inner">
            <span className="sec-tag reveal">Focus Areas</span>
            <h2 className="sec-h reveal" style={{ maxWidth: 560 }}>
              India-Focused Advisory<br />with <em>Global Perspective.</em>
            </h2>
            <p className="sec-sub reveal reveal-delay-1">
              We bring deep advisory experience and investor relationships across six of India's highest-growth business sectors.
            </p>
          </div>
          <div className="about-hero-img reveal reveal-delay-1">
            <img
              src="https://images.unsplash.com/photo-1594233666755-d1cb282abd25?w=800&q=80"
              alt="India business"
            />
          </div>
        </div>
      </div>

      <hr className="rule" />

      <section className="section section-off">
        <div className="svc-grid sectors-grid" style={{ marginTop: 0 }}>
          {sectors.map(({ n, h, p, cap }, i) => (
            <div className={`svc reveal${i % 3 !== 0 ? ` reveal-delay-${(i % 3)}` : ''}`} key={h}>
              <span className="svc-n">{n}</span>
              <h3>{h}</h3>
              <p>{p}</p>
              <div className="svc-sub">Typical capital: {cap}</div>
            </div>
          ))}
        </div>
      </section>

      <div className="cta-strip reveal">
        <h2>Operating in one of these sectors?</h2>
        <p>We welcome a conversation about your business, your capital objectives, and whether there is a basis for engagement.</p>
        <div className="cta-btns">
          <Link className="btn-white" to="/contactus">Register Interest</Link>
        </div>
      </div>

      <Footer />
      <WaFloat />
    </>
  );
}
